import http from '@/middleware'

const reportStorageApi = {
    async getReport(id) {
        const result = await http.get(`/api/report/${id}`)
        return result.data;
    }
}

export default reportStorageApi